<!--
 * @FileDescription: 一级菜单入口（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-06-11（最后更新时间）
 -->
<template>
  <div id="app">
    <a-spin :spinning="isLoding">
      <a-icon slot="indicator" type="loading" style="font-size: 36px" spin />
      <div class="app-header">
        <publicheader></publicheader>
      </div>
      <div class="app-content">
        <div :class="isPackUp?'menu-list-up' :'menu-list'">
          <publicleft></publicleft>
        </div>
        <div class="content" id="content">
          <breadcrumb></breadcrumb>
          <div class="router-view" v-show="!loadFailedView">
            <keep-alive :max="20" :include="keepAliveList">
              <router-view></router-view>
            </keep-alive>
          </div>
          <div class="router-view router-view-load-failed" v-show="loadFailedView">
            <img src="@/assets/image/xitongcuowu.png" alt="" class="image-xitong">
            <span class="text-reload">系统繁忙～请稍后再试！</span>
            <span class="btn-reload" @click="btnLoadFailedView">重新加载</span>
          </div>
        </div>
        <inventoryModel ref="inventoryModel" @onchangeother="onchangeother"></inventoryModel>
      </div>
    </a-spin>
  </div>
</template>
<script>
import publicleft from "./publicleft.vue";
import publicheader from "./publicheader.vue";
import breadcrumb from "./breadcrumb.vue";
 import inventoryModel from '@/views/librarymanage/warehousemanage/model/inventoryModel'
export default {
  name: "RouteView",
  data() {
    return {
      spinning: null,
      isLoding: false,
      breadcrumbInfo: null,
      isPackUp: true,
      contentWidth: 244,
      keepAliveList: [],
      loadFailedView: false
    };
  },
  components: {
    publicleft,
    breadcrumb,
    publicheader,
    inventoryModel,
  },
  computed: {
    isPackUpFunction() {
      return this.$store.state.isPackUp;
    },
    LodingValue() {
      return this.$store.state.isLoding;
    },
    keepAlive() {
      return this.$store.state.keepAlive;
    },
    loadFailed() {
      return this.$store.state.loadFailed;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * @description: 初始化数据（方法描述）
     * @param {参数类型} 参数名称
     * @return void
     */
    init() {
      this.isPackUp = this.$store.state.isPackUp;
      window.document.documentElement.setAttribute("data-theme", "blue");
    },
    btnLoadFailedView() {
      this.loadFailedView = false
      this.$store.state.loadFailed = false
    },
    /**
     * @description: 导入商品后跳出弹框（方法描述）
     */
    onchangeother(value){
      this.$refs.inventoryModel.openother()
    }
  },
  watch: {
    /**
     * @description: 监听路由变化（方法描述）
     * @param {参数类型} 参数名称
     * @return void
     */
    $route: {
      handler: function () {},
      // 深度观察监听
      deep: true,
    },
    isPackUpFunction() {
      this.isPackUp = this.$store.state.isPackUp;
      if (!this.isPackUp) {
        $(".content").css({
          width: "calc(100% - 90px)",
        });
      } else {
        $(".content").css({
          width: "calc(100% - 90px)",
        });
      }
    },
    LodingValue() {
      this.isLoding = this.$store.state.isLoding;
    },
    keepAlive() {
      this.keepAliveList = this.$store.state.keepAlive;
    },
    loadFailed() {
      this.loadFailedView = this.$store.state.loadFailed;
    }
  },
};
</script>
<style lang="scss">
@import "../../main.scss";
.router-view-load-failed {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
 .image-xitong {
   width: 757px;
   height: auto;
   margin-top: 12%;
 }
 .text-reload {
   padding: 25px 0;
 }
 .btn-reload {
    width: 125px;
    height: 36px;
    border: 1px solid #5093EF;
    border-radius: 5px;
    color: #5093EF;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
 }
}
</style>
